const getFileDataString = (type: 'txt' | 'json') => {
  if (type === 'txt') {
    return 'data:text/plain;charset=utf-8';
  }

  if (type === 'json') {
    return 'data:text/json;charset=utf-8';
  }
};

export const downloadFile = (
  fileName: string,
  fileData: Object,
  fileType: 'txt' | 'json',
) => {
  const dataString = `${getFileDataString(fileType)},${encodeURIComponent(
    JSON.stringify(fileData, null, 2),
  )}`;
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataString);
  downloadAnchorNode.setAttribute('download', `${fileName}.${fileType}`);
  document.body.appendChild(downloadAnchorNode);
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};

export const chooseFile = async (accept: string) => {
  return new Promise<File | null>((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.onchange = () => {
      if (!input.files) {
        return resolve(null);
      }

      const file = input.files[0];
      resolve(file);
    };
    input.click();
  });
};
